var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12L9 12M21 6L9 6M21 18L9 18",
    stroke: "#374562",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H4V8",
    stroke: "#374562"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H5.5V12H2.5V14H6",
    stroke: "#374562"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L5.5 16V18H3",
    stroke: "#374562"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18V20H2",
    stroke: "#374562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberList);
export default __webpack_public_path__ + "static/media/number-list.2fb77a7e7587e68e35e492445d780b17.svg";
export { ForwardRef as ReactComponent };